import { type MetaFunction } from '@remix-run/node'
import thehartford from './thehartford.png'

export const meta: MetaFunction = () => [
	{ title: 'The Hartford' },
	{
		name: 'description',
		content: 'We offer insurance from The Hartford.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">The Hartford</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				<img src={thehartford} alt="The Hartford" className="w-64" />
				<h3>History</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Having recently celebrated its 200th birthday, The Hartford is a
					publicly traded company operating on the NY Stock Exchange under
					ticker symbol HIG.
				</p>
				<h3>Products</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					The Hartford offers both personal and commercial lines. They have
					products for a very large variety of business types. Please contact us
					today to see how what an insurance relationship between your business
					and the Hartford would look like.
				</p>
				<h3>Financial Strength</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					A.M. Best rates The Hartford at the level A (Excellent) based, in
					part, by their excellent ability to meet ongoing obligations to
					policyholders.
				</p>
				<h3>Contact Information</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Website:{' '}
					<a
						href="https://www.thehartford.com"
						target="_blank"
						rel="noopener noreferrer"
						className="text-blue-600 underline"
					>
						https://www.thehartford.com (opens in a new tab)
					</a>
				</p>
				<h3>Claims</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Auto &amp; Home: 1-800-243-5860
					<br />
					Business: 1-800-327-3636
				</p>
				<h3>Make a Payment</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Personal Policies:
					<br />
					<a
						title="The Hartford Online Account Access"
						href="https://service.thehartford.com/service/expresspay/landing"
						target="_blank"
						rel="noopener noreferrer"
						className="text-blue-600 underline"
					>
						https://service.thehartford.com/service/expresspay/landing (opens in
						a new tab)
					</a>
					<br />
					<br />
					Commercial Policies:
					<br />
					<a
						title="The Hartford Online Account Access"
						href="https://business.thehartford.com/expresspay"
						target="_blank"
						rel="noopener noreferrer"
						className="text-blue-600 underline"
					>
						https://business.thehartford.com/expresspay (opens in a new tab)
					</a>
					<br />
					<br />
					Billing Address:
					<br />
					The Hartford
					<br />
					PO Box 660916
					<br />
					Dallas, TX 75266-0916
				</p>
			</p>

			<section>
				<h3>Home Office Address</h3>

				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					The Hartford
					<br />
					690 Asylum Avenue
					<br />
					Hartford, CT 06155
				</p>
			</section>
		</main>
	)
}
